const ITEMS = [
  "Gas Safe Registered",
  "Fully Qualified & Insured",
  "Boiler Swaps",
  "System Conversions",
  "Bathrooms",
  "Boiler Servicing",
  "24/7 Breakdowns",
  "5-Star Rated",
];

export const Marquee = () => (
  <div data-testid="trust-marquee" className="relative border-y border-white/10 bg-[#f5641e] py-4 overflow-hidden">
    <div className="flex w-max animate-marquee">
      {[0, 1].map((dup) => (
        <div key={dup} className="flex shrink-0" aria-hidden={dup === 1}>
          {ITEMS.map((t, i) => (
            <div key={`${dup}-${i}`} className="flex items-center">
              <span className="px-6 font-display text-lg sm:text-xl font-extrabold uppercase tracking-tight text-[#0a0a0c]">
                {t}
              </span>
              <span className="text-[#0a0a0c]/50 font-display text-xl">✦</span>
            </div>
          ))}
        </div>
      ))}
    </div>
  </div>
);
